export const SliderData = [
    {
        image: "https://i.ibb.co/gT3ySsH/hero.png",
        heading: "Academic Excellence",
        desc: "Strong reputation and accreditation.Experienced and accomplished faculty and High graduation rates and successful alumni. ",
             




    },
    {
        image: "https://i.ibb.co/M2txByf/slider-3.jpg",
        heading: "Research Opportunities",
        desc: "Availability of undergraduate research programs.State-of-the-art research facilities and resources.Collaboration with industry and other institutions."
    },
    {
        image: "https://i.ibb.co/ZxVPVMB/slider-2.jpg",
        heading: "Campus Facilities",
        desc: "Modern and well-maintained classrooms and laboratories.Libraries with extensive collections and digital resources.On-campus housing and dining options."
    },
    {
        image: "https://i.ibb.co/YL3vCw8/slider-1.jpg",
        heading: "Innovation and Technology",
        desc: "Integration of technology in teaching and learning.Access to cutting-edge tools and software.Programs in emerging fields and interdisciplinary studies."
    },
];